const AboutPage = () => {
  const values = [
    {
      number: '01',
      title: 'Kalite',
      description: 'Premium ekipman ve ürünlerle en yüksek kalite standartları'
    },
    {
      number: '02',
      title: 'Deneyim',
      description: 'Uzman ekibimizle yıllara dayanan profesyonel tecrübe'
    },
    {
      number: '03',
      title: 'Güven',
      description: 'Müşteri memnuniyeti odaklı şeffaf ve güvenilir hizmet'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-500">
      {/* Hero Section */}
      <section className="relative h-64 md:h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/7c3a8892679020118a4ad7cbf9848c58.jpg"
            alt="S&K Detailing Ekibi"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-100 mb-3 md:mb-4">
            Hikayemiz
          </h1>
          <p className="text-base md:text-xl bg-gradient-to-r from-gray-300 via-gray-100 to-gray-400 bg-clip-text text-transparent font-semibold">
            Premium Araç Detaylandırma Tutkusu
          </p>
        </div>
      </section>

      {/* Content Blocks - Zigzag Layout */}
      <section className="py-12 md:py-24">
        <div className="container mx-auto px-4 md:px-6 space-y-12 md:space-y-24">
          {/* Block 1 - Right Aligned */}
          <div className="grid lg:grid-cols-10 gap-8 md:gap-12 items-center">
            <div className="lg:col-span-3"></div>
            <div className="lg:col-span-7 bg-gray-200 p-6 md:p-12 border-l-4 md:border-l-8 border-gray-400 shadow-xl">
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4 md:mb-6">
                S&K Detailing
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">
                S&K Detailing olarak, İzmir'de araç sahiplerine premium detaylandırma hizmetleri sunmanın gururunu yaşıyoruz. Kurulduğumuz günden bu yana, her aracı bir sanat eseri gibi ele alıyor ve en yüksek kalite standartlarında hizmet veriyoruz.
              </p>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Misyonumuz, sadece araçları temizlemek değil, onlara yeni bir hayat vermek ve sahiplerine unutulmaz bir deneyim sunmaktır. Modern ekipmanlarımız ve uzman ekibimizle, her detayda mükemmelliği hedefliyoruz.
              </p>
            </div>
          </div>

          {/* Block 2 - Left Aligned */}
          <div className="grid lg:grid-cols-10 gap-8 md:gap-12 items-center">
            <div className="lg:col-span-7 bg-black p-6 md:p-12 border-r-4 md:border-r-8 border-gray-400 shadow-xl">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-100 mb-4 md:mb-6">
                Profesyonel Ekipman ve Uzmanlık
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">
                En son teknoloji ekipmanlar ve premium kalite ürünler kullanarak, aracınızın her köşesine özen gösteriyoruz. Pasta cila uygulamalarından iç detaylı temizliğe, far temizliğinden motor bakımına kadar geniş hizmet yelpazemizle, aracınızın tüm ihtiyaçlarını karşılıyoruz.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                <div className="flex items-start gap-2 md:gap-3">
                  <i className="ri-check-double-line text-xl md:text-2xl bg-gradient-to-br from-gray-300 to-gray-500 bg-clip-text text-transparent mt-1"></i>
                  <span className="text-gray-300 text-sm md:text-base">Premium Ekipmanlar</span>
                </div>
                <div className="flex items-start gap-2 md:gap-3">
                  <i className="ri-check-double-line text-xl md:text-2xl bg-gradient-to-br from-gray-300 to-gray-500 bg-clip-text text-transparent mt-1"></i>
                  <span className="text-gray-300 text-sm md:text-base">Uzman Ekip</span>
                </div>
                <div className="flex items-start gap-2 md:gap-3">
                  <i className="ri-check-double-line text-xl md:text-2xl bg-gradient-to-br from-gray-300 to-gray-500 bg-clip-text text-transparent mt-1"></i>
                  <span className="text-gray-300 text-sm md:text-base">Kaliteli Ürünler</span>
                </div>
                <div className="flex items-start gap-2 md:gap-3">
                  <i className="ri-check-double-line text-xl md:text-2xl bg-gradient-to-br from-gray-300 to-gray-500 bg-clip-text text-transparent mt-1"></i>
                  <span className="text-gray-300 text-sm md:text-base">Detay Odaklı</span>
                </div>
              </div>
            </div>
            <div className="lg:col-span-3"></div>
          </div>

          {/* Block 3 - Right Aligned */}
          <div className="grid lg:grid-cols-10 gap-8 md:gap-12 items-center">
            <div className="lg:col-span-3"></div>
            <div className="lg:col-span-7 bg-gray-200 p-6 md:p-12 border-l-4 md:border-l-8 border-gray-400 shadow-xl">
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4 md:mb-6">
                İzmir'de Güvenilir Hizmet
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">
                İzmir detaylı oto temizlik alanında uzun yıllara dayanan deneyimimizle, bölgedeki en güvenilir araç detaylandırma merkezi olmaktan gurur duyuyoruz. Müşterilerimizin memnuniyeti bizim için her şeyden önemlidir.
              </p>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Her araç sahibinin farklı ihtiyaçları olduğunu biliyoruz. Bu nedenle, kişiselleştirilmiş hizmet anlayışımızla, aracınızın özel gereksinimlerine uygun çözümler sunuyoruz. Cam çizik onarımından krom parlatmaya, deri tamirine kadar geniş hizmet yelpazemizle yanınızdayız.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-12 md:py-24 bg-gray-600">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-8 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-100 mb-3 md:mb-4">Değerlerimiz</h2>
            <p className="text-gray-200 max-w-2xl mx-auto text-sm md:text-base">
              Başarımızın temelinde yatan prensipler
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-gray-200 p-6 md:p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300"
              >
                <div className="text-4xl md:text-6xl font-extrabold bg-gradient-to-br from-gray-400 to-gray-600 bg-clip-text text-transparent mb-4 md:mb-6">
                  {value.number}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-black mb-3 md:mb-4">{value.title}</h3>
                <p className="text-gray-700 leading-relaxed text-sm md:text-base">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-24 bg-gradient-to-br from-gray-900 via-black to-gray-800 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-r from-gray-400 to-transparent rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-l from-gray-500 to-transparent rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-100 mb-4 md:mb-6">
            Aracınız İçin En İyisini
            <span className="block mt-2 bg-gradient-to-r from-gray-300 via-gray-100 to-gray-400 bg-clip-text text-transparent">
              Hak Ediyor
            </span>
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-6 md:mb-10 max-w-2xl mx-auto">
            Premium araç detaylandırma hizmetlerimiz için bugün bizimle iletişime geçin
          </p>
          <a
            href="/iletisim"
            className="inline-block px-8 md:px-10 py-3 md:py-4 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-400 text-black font-bold rounded-full hover:shadow-2xl hover:shadow-gray-400/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            Hemen Randevu Al
          </a>
        </div>
      </section>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/905050498711?text=Merhaba,%20skdetailing.com.tr%20%C3%BCzerinden%20iletişime%20geçiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-2xl hover:scale-110 hover:shadow-green-500/50 transition-all duration-300 z-50 cursor-pointer group"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl text-white group-hover:text-gray-100"></i>
      </a>
    </div>
  );
};

export default AboutPage;
